import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";

import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	OutlinedInput,
} from "@material-ui/core";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import MomentUtils from "@date-io/moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import MembershipsList from "./MembershipsList";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 70;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const attendees = [
	{ name: "Attendee  1", value: "option1" },
	{ name: "Attendee  2", value: "option2" },
	{ name: "Attendee  3", value: "option3" },
	// Add more options here
];

const ClassAddBooking = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const hasOptions = true;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const addonOptions = [
		{
			item: "Jersey",
			price: "$12 / attendee",
		},
		{
			item: "Music junkie tote bag",
			price: "$25  / attendee",
		},
	];

	const [selectedOptions, setSelectedOptions] = useState([]);

	const handleCheckboxChange = (option) => {
		if (selectedOptions.includes(option)) {
			setSelectedOptions(selectedOptions.filter((item) => item !== option));
		} else {
			setSelectedOptions([...selectedOptions, option]);
		}
	};

	//
	const [selectedDate, handleDateChange] = useState(new Date());

	const handleCloseClick = () => {
		onClose(); // Call the onClose function passed as a prop
	};
	//

	const [selectedAttendees, setSelectedAttendees] = useState(
		attendees.map((attendee) => attendee.value)
	);

	const handleChange = (event) => {
		setSelectedAttendees(event.target.value);
	};

	//
	const dropIn = false;
	const freeTrial = false;
	const monthlyPricing = false;
	const fullSchedule = true;

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			//maxWidth={"sm"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer2,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					<Box position={"absolute"} top={8} left={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<ArrowBackOutlinedIcon />
						</IconButton>
					</Box>
					{isElevated && (
						<Box
							fontSize={20}
							fontWeight={600}
							className={classes.serviceAddTitle}
							ml={8}
							mr={8}
						>
							Booking details
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				dividers={hasOptions}
				style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				<Box
					fontWeight={600}
					fontSize={28}
					pb={4}
					maxWidth={400}
					lineHeight={1.3}
				>
					Booking details
				</Box>
				<Box py={4}>
					{monthlyPricing && (
						<Box display={"flex"} justifyContent={"space-between"} mb={8}>
							<div>
								<Box fontSize={22} fontWeight={600} mb={1}>
									Monthly pricing
								</Box>
								<Box color={"grey.600"} fontSize={15}>
									Sep 6, 2023 – May 22, 2024
								</Box>
							</div>
							<Box fontSize={22} fontWeight={600}>
								$69 / month
							</Box>
						</Box>
					)}

					{dropIn && (
						<Box display={"flex"} justifyContent={"space-between"} mb={8}>
							<div>
								<Box fontSize={22} fontWeight={600} mb={1}>
									Drop-in
								</Box>
								<Box color={"grey.600"} fontSize={15}>
									9 dates remaining
								</Box>
							</div>
							<Box fontSize={22} fontWeight={600}>
								$25 / class
							</Box>
						</Box>
					)}

					{fullSchedule && (
						<Box display={"flex"} justifyContent={"space-between"} mb={8}>
							<div>
								<Box fontSize={22} fontWeight={600} mb={1}>
									Full schedule
								</Box>
								<Box color={"grey.600"} fontSize={15}>
									Sep 6, 2023 – May 22, 2024
								</Box>
							</div>
							<Box fontSize={22} fontWeight={600}>
								$420
							</Box>
						</Box>
					)}

					{freeTrial && (
						<>
							<Box mb={8}>
								<Box display={"flex"} justifyContent={"space-between"}>
									<div>
										<Box fontSize={22} fontWeight={600} mb={1}>
											Free trial
										</Box>
										<Box color={"grey.600"} fontSize={15}>
											New students only
										</Box>
									</div>
									<Box fontSize={22} fontWeight={600}>
										Free
									</Box>
								</Box>
								<Box mt={4} color={"grey.500"} fontSize={14} lineHeight={1.5}>
									Only new students are eligible for a free trial on select
									activities. Signing up for a free trial does not reserve your
									spot for the remainder of the semester.
								</Box>
							</Box>
						</>
					)}

					<Box mb={5}>
						<Box fontSize={17} fontWeight={600} mb={1.5}>
							Who is attending?
						</Box>
						<Box width={{ xs: "100%", sm: 350 }}>
							<FormControl variant="outlined" fullWidth>
								<Select
									id="multi-select-dropdown"
									multiple
									native={false}
									value={selectedAttendees || "Add attendee(s)"}
									onChange={handleChange}
									IconComponent={ExpandMoreIcon}
									placeholder="Add attendee(s)"
									//input={<OutlinedInput placeholder="Add attendee(s)" />}
									renderValue={(selected) =>
										selected.length === 0
											? "Add attendee(s)"
											: selected
													.map(
														(value) =>
															attendees.find((option) => option.value === value)
																.name
													)
													.join(", ")
									}
								>
									{attendees.map((option) => (
										<MenuItem
											key={option.value} //value={option.value}
											dense
										>
											<Checkbox
												color="primary"
												checked={selectedAttendees.indexOf(option.value) > -1}
											/>
											<ListItemText primary={option.name} />
										</MenuItem>
									))}
									<MenuItem>
										<ListItemText
											primary={
												<>
													<Box
														color={"primary.main"}
														fontWeight={600}
														textAlign={"center"}
													>
														+ Add attendee
													</Box>
												</>
											}
										/>
									</MenuItem>
								</Select>
							</FormControl>
						</Box>
					</Box>

					{dropIn && (
						<Box mb={5}>
							<Box fontSize={17} fontWeight={600} mb={1.5}>
								Select dates
							</Box>
							<Box width={{ xs: "100%", sm: 350 }}>
								<MuiPickersUtilsProvider utils={MomentUtils}>
									<DatePicker
										disableToolbar
										id="date"
										inputVariant="outlined"
										variant="inline"
										onFocus={() => handleFocus("date")}
										onBlur={() => handleBlur("date")}
										value={selectedDate}
										format="MM/dd/yyyy"
										onChange={handleDateChange}
										animateYearScrolling
										fullWidth
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton>
														<CalendarTodayIcon />
													</IconButton>
												</InputAdornment>
											),
										}}
									/>
								</MuiPickersUtilsProvider>
							</Box>
						</Box>
					)}

					{freeTrial && (
						<Box mb={5}>
							<Box fontSize={17} fontWeight={600} mb={1.5}>
								Select date
							</Box>
							<Box width={{ xs: "100%", sm: 350 }}>
								<FormControl variant="outlined" fullWidth>
									<Select
										native
										value={"placeholder"}
										//onChange={handleChange}
										IconComponent={ExpandMoreIcon}
										placeholder="Select date"
										inputProps={{
											name: "date",
											id: "date",
										}}
										className={classes.appointmentInput}
									>
										<option value="placeholder" disabled>
											Select date
										</option>
										<option value="day">Saturday, March 7, 2024</option>
										<option value="week">Saturday, March 14, 2024</option>
										<option value="week">Saturday, March 21, 2024</option>
									</Select>
								</FormControl>
							</Box>
						</Box>
					)}

					{fullSchedule && (
						<Box mb={5}>
							<Box fontSize={17} fontWeight={600} mb={1.5}>
								How would you like to pay?
							</Box>
							<Box width={{ xs: "100%", sm: 350 }}>
								<FormControl variant="outlined" fullWidth>
									<Select
										native
										value={"placeholder"}
										//onChange={handleChange}
										IconComponent={ExpandMoreIcon}
										placeholder="Select date"
										inputProps={{
											name: "date",
											id: "date",
										}}
										className={classes.appointmentInput}
									>
										<option value="placeholder" disabled>
											Select payment plan
										</option>
										<option value="day">Pay in full</option>
										<option value="week">
											3 installments of $150 (2 of 3 remaining)
										</option>
									</Select>
								</FormControl>
							</Box>
						</Box>
					)}

					{/* <Box my={8}>
						<Divider light />
					</Box> */}

					{hasOptions && (
						<div>
							<Box my={8}>
								<Divider light />
							</Box>
							<Box
								display={"flex"}
								justifyContent={"space-between"}
								alignItems={"center"}
								mb={2}
							>
								<div>
									<Box fontSize={22} fontWeight={600} mb={1}>
										Additional options
									</Box>
									<Box color={"grey.600"} fontSize={15}>
										Optional
									</Box>
								</div>

								{/* <Box fontSize={14} fontWeight={600} color={"#c31c3b"}>
									2 spots left!
								</Box> */}
							</Box>
							<List>
								{addonOptions.map((option, index) => (
									<ListItem
										key={index}
										button
										onClick={() => handleCheckboxChange(option.item)}
										classes={{
											root: classes.listItem,
											button: classes.listButton,
											container: classes.listItemContainer,
										}}
										disableGutters
									>
										<ListItemText
											classes={{
												primary: classes.listPrimary,
												secondary: classes.listSecondary,
												//multiline: classes.listMultiline,
											}}
											primary={option.item}
											secondary={option.price}
										/>
										<ListItemSecondaryAction>
											<Checkbox
												color="primary"
												edge="end"
												checked={selectedOptions.includes(option.item)}
												onChange={() => handleCheckboxChange(option.item)}
											/>
										</ListItemSecondaryAction>
									</ListItem>
								))}
							</List>
						</div>
					)}

					<div>
						<Box my={8}>
							<Divider light />
						</Box>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={2}
						>
							<div>
								<Box fontSize={22} fontWeight={600} mb={1}>
									Memberships and packs
								</Box>
								<Box color={"grey.600"} fontSize={15}>
									Optionally purchase a membership or pack to save
								</Box>
							</div>

							{/* <Box fontSize={14} fontWeight={600} color={"#c31c3b"}>
								Upgrade and save!
							</Box> */}
						</Box>
						<MembershipsList />
					</div>

					<div>
						<Box my={8}>
							<Divider light />
						</Box>
						<Box
							display={"flex"}
							justifyContent={"space-between"}
							alignItems={"center"}
							mb={5}
						>
							<div>
								<Box fontSize={22} fontWeight={600} mb={1}>
									Summary
								</Box>
								{/* <Box color={"grey.600"} fontSize={15}>
									Optional
								</Box> */}
							</div>

							{/* <Box fontSize={14} fontWeight={600} color={"#c31c3b"}>
									2 spots left!
								</Box> */}
						</Box>

						{/* <Box mb={4} pt={3}>
							<Box fontSize={17} fontWeight={600} mb={1.5}>
								Summary
							</Box>
						</Box> */}

						<Box display={"flex"} justifyContent={"space-between"} mb={5}>
							<div>
								<Box mb={1}>Drop-in (Tom)</Box>
								<Box color={"grey.600"} fontSize={14}>
									1 day × $18.00
								</Box>
							</div>
							<div>$18.00</div>
						</Box>

						<Box display={"flex"} justifyContent={"space-between"} mb={5}>
							<div>
								<Box mb={1}>Drop-in (Bobby)</Box>
								<Box color={"grey.600"} fontSize={14}>
									1 day × $18.00
								</Box>
							</div>
							<div>$18.00</div>
						</Box>

						<Box display={"flex"} justifyContent={"space-between"} mb={5}>
							<div>
								<Box mb={1}>Music Junkie Tote Bag</Box>
								<Box color={"grey.600"} fontSize={14}>
									2 × $18.00
								</Box>
							</div>
							<div>$36.00</div>
						</Box>

						<Box display={"flex"} justifyContent={"space-between"} mb={5}>
							<div>
								<Box mb={1}>Group discount</Box>
								<Box color={"grey.600"} fontSize={14}>
									1 attendee (15% off)
								</Box>
							</div>
							<div>-$2.70</div>
						</Box>
					</div>

					{/* <div>
						• Monthly Pricing: Charged on the 1st of the month • Registration
						Fee (Includes Supplies & T-Shirt) ($25) • Sibling Discounts: Second
						Child (10%), Third Child (10%), Any Additional Child (10%)
					</div> */}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: "20px 24px 24px 24px" }}>
				<Box display={"flex"} width={"100%"} flexDirection={"column"}>
					<Box
						display={"flex"}
						alignItems={"center"}
						justifyContent={"space-between"}
						mb={4}
					>
						<Box fontSize={17} fontWeight={600}>
							Subtotal
						</Box>
						<Box fontSize={17} fontWeight={600}>
							$45.00
						</Box>
					</Box>
					<Button
						fullWidth
						onClick={handleCloseClick}
						size={"large"}
						variant="contained"
						color="primary"
						disableElevation
					>
						Add to booking
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};

ClassAddBooking.propTypes = {};
export default ClassAddBooking;
